<div class="ct-page-container ct-clients-page ct-max-width">
  <div class="ct-page-header">
    <mat-checkbox [(ngModel)]="showJiraTable" (ngModelChange)="onToggle()">
        Jira Enable
    </mat-checkbox>

    <div *ngIf="showJiraTable" (click)="checkConncetion()" class="ct-add-link">
      <a  style="padding-top: 3px;" >Check connections</a>
    </div>
  </div>
<div class="ct-data-table-wrapper">
  <p-table
  class="ct-grid-container ct-grid-row-border"
  *ngIf="showJiraTable"
  [value] = "tableData">
  <ng-template pTemplate="header">
    <tr>
      <th>
        Setting name
      </th>
      <th>
        Api Token
      </th>
      <th>
        Domain
      </th>
      <th>
        User Email
      </th>
      <th>
        Account id
      </th>
      <th>
        Edit
      </th>
      <th>
        Projects
      </th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-row let-rowIndex="rowIndex">
    <tr>
      <td class="ct-info-col">{{row.settingName}}</td>
      <td>
        <i class="fa"
          [ngClass]="row.apiTokenStatus ? 'fa-check' : 'fa-times'"
          [style.color]="row.apiTokenStatus ? 'green' : 'red'"
          >
        </i>
      </td>
      <td>{{row.domain}}</td>
      <td class="ct-info-col">{{row.userEmail}}</td>
      <td>
        <i class="fa"
          [ngClass]="row.isEnableConntection ? 'fa-check' : 'fa-times'"
          [style.color]="row.isEnableConntection ? 'green' : 'red'"
          ></i>
      </td>
      <td class="ct-small-padding">
          <a class="ct-grid-settings-icon" (click) = "openConnectionDialog(row)"></a>
      </td>
      <td class="ct-small-padding">
        <a class="ct-grid-settings-icon" (click)="onJiraProjectDialog(row)"></a>
      </td>
    </tr>
  </ng-template>
  </p-table>
</div>
</div>
